export const selectUser = (state) => state.user;
export const selectModal = (state) => state.modal;
export const selectProjects = (state) => state.portfolio.projects;
export const selectPosts = (state) => state.blog.posts;
